import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../../../../auth/user.service';
import { CommonUtil } from '../../../../shared/services/utility/common.service';
import { SiteDashboardService } from '../../site-dashboard.service';
import { SideMenuService } from '../../../../shared/side-menu/side-menu.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-plinks-performance',
  templateUrl: './plinks-performance.component.html',
  styleUrls: ['./plinks-performance.component.css']
})
export class PlinksPerformanceComponent implements OnInit, OnDestroy {

  user;
  customerId;
  siteId;
  data;
  sitePlinksData;
  siteTags;
  sitePlinksTags;
  siteDevicesHaveNoData: boolean = false;
  siteHasDevices: boolean = true;
  siteInfo: any;
  sideMenuSubscription: Subscription = new Subscription();
  activeDashboardSubscription: Subscription = new Subscription();

  constructor(
    private siteDashboardService: SiteDashboardService,
    private userService: UserService,
    private route: ActivatedRoute,
    private commonUtil: CommonUtil,
    private sideMenu: SideMenuService,
  ) {
    this.siteDashboardService.setActiveTab('polarlink');
    this.siteDashboardService.setActiveSubTab('polarlink-performance');
  }

  ngOnInit() {
    this.user = this.userService.getCurrentUser();

    this.customerId = this.route.parent.parent.snapshot.params.customerid || 0;
    this.siteId = this.route.parent.parent.snapshot.params.siteid || 0;

    this.sideMenuSubscription = this.sideMenu.currentSite.subscribe(data => {
      this.siteInfo = data;
    });

    this.activeDashboardSubscription = this.siteDashboardService.activeDashboardData.subscribe(data => {
      let tempData: any = data;

      this.siteHasDevices = (data.polarLinksInSite.count > 0);
      this.sitePlinksData = this.commonUtil.arrayToAssociativeArray(data.polarLinksInSite.list, 'deviceid');

      var haveData = false;

      for(var name in data.data) {
        var widgetData = data.data[name];
        haveData = haveData || (widgetData['90'] && Object.keys(widgetData['90']).length > 0);
      }

      this.siteDevicesHaveNoData = !haveData;

      this.siteTags = [];

      var Tags = data.polarLinksInSite.tags;
      var siteTags = Tags.siteTags;
      var deviceTags = Tags.deviceTags;

      for(var i in siteTags) {
        this.siteTags.push(siteTags[i]);
      }

      this.sitePlinksTags = {};
      for(let plinkId in deviceTags) {
        let plinkTagsIds = deviceTags[plinkId];
        for (let i in plinkTagsIds) {
          let tag = plinkTagsIds[i];
          let tagId = tag.tagid;
          if (!this.sitePlinksTags[tagId]) {
            this.sitePlinksTags[tagId] = [];
          }
          this.sitePlinksTags[tagId].push(plinkId);
        }
      }

      tempData.plinksData = this.sitePlinksData;
      tempData.siteTags = this.siteTags;
      tempData.sitePlinksTags = this.sitePlinksTags;

      this.data = tempData;
    });

    this.siteDashboardService.getPolarLinkDashboardData(this.customerId, this.siteId);
    // Only load expensive performance data when this component is actually active
    // Check if current route is the performance route
    // const currentUrl = this.route.parent.parent.snapshot.url.join('/');
    // if (currentUrl.includes('performance')) {
    //   this.siteDashboardService.getChargersDashboardData(this.customerId, this.siteId);
    // }
  }

  ngOnDestroy() {
    this.sideMenuSubscription.unsubscribe();
    this.activeDashboardSubscription.unsubscribe();
  }
}
